import swal from "sweetalert";
import axiosInstance from "../api";
import { setColorListData, setSingleSize, setSinlgeColor, setSizeListData } from "../../reusableSlice";


export const getAllColor = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`admin/colors`, { params: data });
      console.log(response,"sdfsf")
      if (response?.data) {
        dispatch(setColorListData(response?.data?.response))
      } else {
        dispatch(setColorListData([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setColorListData([]))
    }
  };

  export const addColor = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("admin/colors", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/color")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
     // console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const getSingleColor = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`admin/colors/${id}`);
      console.log(response,"responsesdfssfs")
      if (response?.data) {
        dispatch(setSinlgeColor(response?.data?.response))
      } else {
        dispatch(setSinlgeColor([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setSinlgeColor([]))
    }
  };

  export const updateOneColor = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.put("admin/colors", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/color")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
     // console.error(err);
    } finally {
      setLoading(false);
    }
  };



 

  export const deleteOneColor = (id) => async (dispatch) => {
    // setLoading(true);
    try {
      const response = await axiosInstance.delete(`admin/colors/${id}`);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        window.location.reload()
        // navigate("/membership")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
     // console.error(err);
    } finally {
      // setLoading(false);
    }
  };


